import React from "react";
import { BodyText } from "./nessie-web";
import { LabelText } from "./LabelText";

const LoginWithCodeButton = ({ loginWithCode }: { loginWithCode: () => void }) => {
  return (
    <div style={{ display: "flex", gap: "12px", alignItems: "baseline", justifyContent: "center", marginLeft: "30px" }}>
      <LabelText style={{ marginTop: "18px" }} onClick={loginWithCode}>
        <BodyText>Login without a password</BodyText>
      </LabelText>
      <BodyText sx={{ marginRight: "18px" }}>{">"}</BodyText>
    </div>
  );
};

export default LoginWithCodeButton;
